module.exports = __webpack_public_path__ + "img/new-home.befd2e8b.svg";